import { TableHeadCell } from "@digital-services/ui";

export const AppRolesHeaderRow = () => {
  return (
    <tr className="leading-[0px]" data-testid="thead">
      <TableHeadCell className="w-50">Added at</TableHeadCell>
      <TableHeadCell className="min-w-max">Application</TableHeadCell>
      <TableHeadCell>Role</TableHeadCell>
      <TableHeadCell className="w-40">Actions</TableHeadCell>
    </tr>
  );
};
